export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">About Remodeling Site</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              With 5 years of dedicated experience in Chicago, we transform houses into dream homes with exceptional craftsmanship and attention to detail.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/7a8aa5bd3b1913440fa260c27b106630.jpg"
                alt="Remodeling Site team at work"
                className="rounded-lg shadow-lg w-full h-96 object-cover object-top"
              />
            </div>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Story</h3>
                <p className="text-gray-600 leading-relaxed">
                  Founded in 2019, Remodeling Site has been serving the Chicago area with premium renovation services. We started as a focused remodeling company with a clear mission: to deliver exceptional quality and customer service that exceeds expectations.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Commitment</h3>
                <p className="text-gray-600 leading-relaxed">
                  Every project we undertake reflects our commitment to excellence. From initial consultation to final walkthrough, we ensure transparent communication, timely completion, and superior craftsmanship that stands the test of time.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-6 pt-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">200+</div>
                  <div className="text-gray-600">Projects Completed</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">5</div>
                  <div className="text-gray-600">Years Experience</div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16">
            <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">Why Choose Us</h3>
            <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">Licensed & Insured</h4>
                <p className="text-gray-600">
                  Fully licensed contractors with comprehensive insurance coverage for your peace of mind.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">Quality Guarantee</h4>
                <p className="text-gray-600">
                  All our work comes with a comprehensive warranty and satisfaction guarantee.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}